import { render } from "./ProcessingMethodsSection.vue?vue&type=template&id=51e4de38"
import script from "./ProcessingMethodsSection.vue?vue&type=script&lang=js"
export * from "./ProcessingMethodsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__